$(function () {
    $('.youtube-playlist .stretched-link').click(function (e) {
        e.preventDefault();
        var $link = $(e.currentTarget);
        var $player = $(`#${$link.data('player-ref')}`);

        $player.find('iframe').attr('src', $link.data('video-embed-url'));
        $player.find('.h3').html($link.data('video-title'));
        $player.find('.lead').html($link.data('video-description'));
        $player.get(0).scrollIntoView({ behavior: 'smooth' });
    });
});
